/* eslint-disable no-undef */

// import BrowserPrint,{Device,Configuration} from'browserprint-es'
import { $notify } from '@/global'
import {i18n} from '@/api/i18n'
import { commonAddLog } from '@/api/biz/shipment/pack/paperlessPackageTag';
import {printPointEnd} from '@/utils/setMethods'
require('../lib/zplBrowserPrint.min');

const getDeviceCallback = (deviceList) => {
  console.log("Devices: \n" + JSON.stringify(deviceList, null, 4))
}
const errorCallback = (errorMessage) => {
  console.log("Error: " + errorMessage)
}
export const getLocalDevices = () => {
  zebraBrowserPrint.getLocalDevices(getDeviceCallback, errorCallback)
}

export const printZPL = async (fileUrl, outboundNo) => {
  console.log("开始调用zpl打印....");
  commonAddLog('printZPL',outboundNo,`复核---zpl打印Url:${fileUrl}`)
  const startTime=new Date().getTime()
  if(window.location.protocol === 'https:' && fileUrl && fileUrl.startsWith('http://')){
    fileUrl = fileUrl.replace('http://', 'https://')
  }
  return new Promise((resolve, reject) => {
    BrowserPrint.getDefaultDevice("printer", function(device) {
      console.log('device', device)
      // device.manufacturer: "Zebra Technologies"
      // device.provider: "com.zebra.ds.webdriver.desktop.provider.DefaultDeviceProvider"
      device.sendFile(fileUrl, ()=> {
        printPointEnd(
          'ZPL',
          startTime,
        )
        console.log('打印完成')
        commonAddLog('printZPL',outboundNo,`复核---zpl打印完成`)
        resolve();
      }, (e) => {
        console.log('zpl打印失败,请确认是否为斑马打印机或重试!')
        printPointEnd(
          'ZPL',
          startTime,
          {eptCustMessage:'zpl打印失败:请确认是否为斑马打印机或重试'}
        )
        commonAddLog('printZPL',outboundNo,`复核---zpl打印失败Url:${fileUrl}`)
        $notify.warning(i18n.t('zplPrintFailed'));
        reject(e);
      })
    }, function(error){
      console.log('zpl打印失败,请确认是否为斑马打印机或重试!')
      commonAddLog('printZPL',outboundNo,`复核---zpl打印失败Url:${fileUrl}`)
      $notify.warning(i18n.t('zplPrintFailed'));
      reject(error);
    })
  })
}

// browserprint-es 先安装"browserprint-es": "0.0.3",
export const printZPLByEs = async (fileUrl) => {
  console.log("开始调用zpl打印....");
  return new Promise(async (resolve, reject) => {
    const device= await BrowserPrint.getDefaultDeviceAsync('printer');
    console.log('device', device)
    await device.sendUrl(fileUrl, ()=> {
      console.log('打印完成')
      resolve()
    },(e) => {
      console.log('zpl打印失败,请确认是否为斑马打印机!')
      reject(e);
    })
  })
  
}
